import { Link } from 'carbon-components-react'
import React from 'react'

export default ({icon, title, noMargin, link, linkText, linkOnClick}) => (
    <div style={{display: 'flex', alignItems: 'center', marginBottom: noMargin ? 0 : '0.5rem',}}>
        {icon && React.createElement(icon, { style: { marginRight: '0.25rem', marginLeft: '0.25rem' } })}
        <p style={{fontSize: 16, fontWeight: 'bold', flex: 1}}>{title}</p>
        {link && <Link style={{cursor: 'pointer'}} onClick={linkOnClick}>{linkText}</Link>}
    </div>
)